<template>
  <v-container id="error-view" class="fill-height text-center" tag="section">
    <v-row justify="center">
      <v-col cols="auto">
        <h1 class="primary--text text-h1 font-weight-medium">{{status}}</h1>
        <div class="text-h2 font-weight-medium pt-16 pb-10">{{message}}</div>

        <v-btn rounded class="primary white--text" large to="/">Powrót</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ErrorView',
    data: () => ({
    status: null,
    message: null,
  }),
  beforeMount() {
    this.status = this.$route.query.status
    if (this.status == 500) {
      this.message = "Wewnętrzny błąd serwera"
    } else if (this.status == 409) {
      this.message = "Konflikt. Spróbuj ponownie"
    } else if (this.status == 404) {
      this.message = "Nie znaleziono strony"
    } else if (this.status == 403) {
      this.message = "Nie masz uprawnień do dostępu do tej strony"
    } else if (this.status == 401) {
      this.message = "Nieautoryzowany dostęp. Zaloguj się"
    } else if (this.status == 400) {
      this.message = "Błędne żądanie. Sprawdź swoje dane"
    } else {
      this.message = "Wystąpił nieoczekiwany błąd"
    }
  },
  }
</script>

<style lang="sass">
#error-view h1.text-h1
  font-size: 14rem !important
</style>
